module.exports = __webpack_public_path__ + "img/serviceBj.e78cf24e.png";